<template>
    <div style="position:fixed;top:0;left:0;background:rgba(255, 255, 255, 0.5);width:100%;z-index:1000;">
      <div>
        <div class="header">
          <div class="header-mobile"><span class="header-mobile-label">电话:</span>+86（10）6489 6300</div>
          <div class="header-wrapper">
            <img src="../../img/logo.png" class="header-img" @click="toHomePage">
            <div class="header-item">
              <span v-if="!isShowSearch">
                <span v-if="isEnglish == 0">
                  <span class="header-btn" :class="{ actived: routeName === 'homePage' }" v-on:click="clickItem(0)">首页</span>
                  <span class="header-btn" :class="{ actived: routeName === 'about' && aboutId === '0' }" v-on:click="clickItem(1)">走进环中</span>
                  <span class="header-btn" :class="{ actived: routeName === 'hzly' }" v-on:click="clickItem(2)">业务领域</span>
                  <span class="header-btn" :class="{ actived: routeName === 'lawyer' }" v-on:click="clickItem(3)">环中律师</span>
                  <span class="header-btn" :class="{ actived: routeName === 'hzyj' }" v-on:click="clickItem(4)">主要业绩</span>
                  <span class="header-btn" :class="{ actived: routeName === 'hzcbw' }" v-on:click="clickItem(5)">出版物</span>
                  <span class="header-btn" :class="{ actived: routeName === 'about' && aboutId === '1' }" v-on:click="clickItem(6)">加入我们</span>
                  <span class="header-btn" :class="{ actived: routeName === 'contact' }" v-on:click="clickItem(7)">联系我们</span>
                  <div class="header-search" v-on:click="moveSearch" >
                    <img src="../../img/search.png" class="header-sure">
                  </div>
                </span>
                <span v-else>
                    <span class="header-btn" :class="{ actived: routeName === 'homePage' }" v-on:click="clickItem(0)">Home</span>
                    <span class="header-btn" :class="{ actived: routeName === 'about' && aboutId === '0' }" v-on:click="clickItem(1)">Welcome</span>
                    <span class="header-btn" :class="{ actived: routeName === 'hzly' }" v-on:click="clickItem(2)">Expertise</span>
                    <span class="header-btn" :class="{ actived: routeName === 'lawyer' }" v-on:click="clickItem(3)">Professionals</span>
                    <span class="header-btn" :class="{ actived: routeName === 'hzyj' }" v-on:click="clickItem(4)">Achievements</span>
                    <span class="header-btn" :class="{ actived: routeName === 'hzcbw' }" v-on:click="clickItem(5)">Publications</span>
                    <span class="header-btn" :class="{ actived: routeName === 'about' && aboutId === '1' }" v-on:click="clickItem(6)">Careers</span>
                    <span class="header-btn" :class="{ actived: routeName === 'contact' }" v-on:click="clickItem(7)">Contact us</span>
                    <div class="header-search" v-on:click="moveSearch" >
                      <img src="../../img/search.png" class="header-sure">
                    </div>
                </span>
              </span>
              <div style="float:left;margin-top:25px;" v-show="isShowSearch" >
                <div class="header-searchNews">
                  <input type="text" class="header-input" v-model="searchModel" v-if="isEnglish == 0"
                        placeholder="请输入关键字">
                  <input type="text" class="header-input" v-else v-model="searchModel" placeholder="Please input keywords">
                  <div style="float:left;">
                    <img src="../../img/search.png" class="header-submit"  v-on:click="search">
                  </div>
                </div>
                <div v-on:click="outSearch" style="cursor:pointer;float:left;margin-left:40px;color:black;font-size:18px;padding-top:10px;">X</div>
              </div>
              <div class="header-english" v-if="isEnglish == 0" v-on:click="clickIsEnglish(0)">
                English
              </div>
              <div class="header-english" v-else v-on:click="clickIsEnglish(1)">中文</div>
            </div>
          </div>
        </div>
      </div>
    </div>

</template>
<style scoped lang="css">
  .header{
    width: 100%;
    height: 125px;
    margin:0 auto;
  }
  .header-mobile {
    width: 100%;
    box-sizing: border-box;
    padding:0 60px;
    text-align: right;
    line-height: 34px;
    border-bottom: solid 1px #EDEDED;
    color: #CCA876;
  }
  .header-mobile-label {
    color: #999;
    padding-right: 10px;
    font-size: 14px;
  }
  .header-wrapper {
    width: 100%;
    box-sizing: border-box;
    padding:0 60px;
    overflow: hidden;
  }
  .header-img{
    float:left;
    width:285px;
    height:45px;
    margin-top:20px;
    cursor: pointer;
  }
  .header-item{
    float:right;
    height:90px;
  }
  .header-btn{
    font-size:16px;
    color:black;
    float:left;
    line-height:90px;
    padding:0 10px;
    width:auto;
    text-align:center;
    cursor:pointer;
  }
  .header-btn.actived {
    color: #b69859;
  }
  .header-btn:hover{
    color: #b69859;
  }
  .header-search{
    float:left;
    margin-left:10px;
    padding:0 10px;
    overflow:hidden;
    cursor:pointer;
    height:100%;
  }
  .header-sure{
    width:20px;
    border-radius:4px 0px 0px 4px;
    height:20px;
    border:0;
    float:left;
    margin-top:37px;
  }
  .header-english{
    float:left;
    margin-left:25px;
    color:black;
    font-size:16px;
    line-height:90px;
    cursor:pointer;
  }
  .header-english:hover{
    color:rgb(69, 90, 162);
  }
  .header-searchNews{
     width:280px;
     height:40px;
     z-index:100;
     border:1px solid #d1d1d1;
     border-radius:6px;
    float: left;
  }
  .header-input{
    border:0px;
    border-radius:4px 0 0 4px;
    height:34px;
    width:220px;
    margin-top:3px;
    color:black;
    outline:none;
    margin-left:8px;
    padding-left:10px;
    font-size: 14px;
    float:left;
    background: transparent;
  }
  .header-submit{
    cursor:pointer;
    width:25px;
    height:25px;
    border:0;
    margin-top:10px;
    margin-left:10px;
    border-radius:0 4px 4px 0;
    font-size: 0;
  }
  @media screen and (max-width: 1280px) {
    .header-wrapper {
      width:1200px;
    }
    .header-img {
      width: 200px;
      height: 35px;
      margin-top: 25px;
    }
  }
  input::-webkit-input-placeholder{
    color:#999;
  }
  input::-moz-placeholder{   /* Mozilla Firefox 19+ */
    color:#999;
  }
  input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
    color:#999;
  }
  input:-ms-input-placeholder{  /* Internet Explorer 10-11 */
    color:#999;
  }
</style>
<script>
    import $ from "jquery";
    export default{
        data(){
            return{
              isShowSearch:false,
              clickIndex:window.clickIndex,
              isEnglish:window.isEnglish,
              searchModel:'',
              routeName: '',
              aboutId: undefined
            }
        },
        components:{

        },
        created () {
          const _route = this.$route
          this.routeName = _route.name
          if (_route.name === 'about') {
            this.aboutId = _route.query.id
          } else {
            this.aboutId = undefined
          }
        },
        watch:{
          clickIndex:function(val){},
          '$route' (newVal, oldVal) {
            this.routeName = newVal.name
            if (this.routeName === 'about') {
              this.aboutId = newVal.query.id
            } else {
              this.aboutId = undefined
            }
          }
        },
        mounted () {
          //$(".header-btn").eq(this.clickIndex).css({
          //    "background":"darkgray"
          //  })
        },
        methods:{
          toHomePage () {
            this.$router.push({ path: '/' })
          },
          search:function(){
            if (this.searchModel.length != 0) {
                $(".header-btn").css({
                "background":""
              })
               this.$router.push({path:'/search', query:{search:this.searchModel}});
            }
          },
          clickIsEnglish:function(index){
             if(index == 0) {
              sessionStorage.setItem('isEnglish', 1);
             } else {
              sessionStorage.setItem('isEnglish', 0);
             }
             location.reload();
          },
          moveSearch:function(){
            //$(".header-search").css({
            //  "background":"darkgray"
            //})
            this.isShowSearch = true;
          },
          outSearch:function(ev){
              this.isShowSearch = false;
          },
          clickItem:function(index){
            this.clickIndex = sessionStorage.getItem('clickIndex')
            if (index == 0) {
              this.$router.push('/');
            } else if (index == 1) {
              this.$router.push({path:'/about', query:{id:"0"}});
            } else if (index == 6) {
              this.$router.push({path:'/about', query:{id:"1"}});
            } else if (index == 7) {
             // if (this.clickIndex == 0) {
             //   $('html, body').animate({
             //     scrollTop: $(".homePage-active").offset().top - 90
             //   }, 500);
             //   index = 0;
             // } else {
                this.$router.push({path:'/contact', query:{id:"0"}});
             // }
            } else if (index == 2) {
              //if (this.clickIndex == 0) {
              //  $('html, body').animate({
              //    scrollTop: $(".home-zone").offset().top - 90
              //  }, 500);
              //  index = 0;
              //} else {
                this.$router.push({path:'/hzly'});
              //}
            } else if (index == 4){
              this.$router.push({path:'/hzyj', query:{id:"0"}});
            } else  if (index == 5) {
              this.$router.push({path:'/hzcbw'});
            } else if (index == 3) {
              this.$router.push({path:'/lawyer'});
            }
            sessionStorage.setItem('clickIndex', index)
            this.clickIndex = index;
            $(".header-btn").css({
              "background":""
            })
            //$(".header-btn").eq(index).css({
            //  "background":"darkgray"
            //})
          }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/components/header.vue